import { render } from "./newPrix.vue?vue&type=template&id=362c4049&scoped=true"
import script from "./newPrix.vue?vue&type=script&lang=js"
export * from "./newPrix.vue?vue&type=script&lang=js"

import "./newPrix.vue?vue&type=style&index=0&id=362c4049&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-362c4049"]])

export default __exports__